/**
 * @generated SignedSource<<27a886f550c6b1fd2e6d484fc8cf17b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveMethodInstallment_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly availablePaymentMethodsList: ReadonlyArray<{
    readonly installments?: ReadonlyArray<{
      readonly discount: number;
      readonly installmentNumber: number;
      readonly value: number;
    }>;
  } | null | undefined> | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentType": "PaymentActiveMethodInstallment_charge";
};
export type PaymentActiveMethodInstallment_charge$key = {
  readonly " $data"?: PaymentActiveMethodInstallment_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveMethodInstallment_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveMethodInstallment_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueWithDiscount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "availablePaymentMethodsList",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethodAvailableInstallment",
              "kind": "LinkedField",
              "name": "installments",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "discount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PaymentMethodAvailableInstallments",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "e94918525c8d488a47514f329761c6af";

export default node;
